import isComingSoon from "./isComingSoon";

const getIsEarlyAccessCategoryComingSoon = (state) =>
  isComingSoon({ loyaltyBenefit: state.category.details?.loyaltyBenefit });

export default getIsEarlyAccessCategoryComingSoon;
